import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges } from '@angular/core';
import { CloudState } from '../../dashboard/cloudState.model';
import { CleanActiveJobHelper } from '../../helpers/clean-active-job.helper';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-refresh',
  template: `
    @if (!refreshStatus) {
      <span class="refresh-container" (mouseover)="refreshStatus = true">
        @if (offline) {
          <span class="updating"><mat-icon>cloud_off</mat-icon>Cannot reach server</span>
        }
        @if (!offline) {
          <span>
            @switch (cloudState) {
              @case ('FETCHING') {
                <span class="updating"
                  ><mat-icon>cloud_download</mat-icon> Retrieving from cloud<span>.</span><span>.</span
                  ><span>.</span></span
                >
              }
              @case ('SAVING') {
                <span class="updating"
                  ><mat-icon>cloud_upload</mat-icon> Uploading your work<span>.</span><span>.</span><span>.</span></span
                >
              }
              @default {
                <span class="cloud-done"><mat-icon>cloud_done</mat-icon> {{ updatingTimerInfo() }}</span>
              }
            }
          </span>
        }
      </span>
    }
    @if (refreshStatus) {
      <span
        class="update-display body-1"
        (mouseout)="refreshStatus = false"
        [class.loading]="loading"
        (click)="refresh.emit(); cleanActiveJobHelper.clearSessionStorageFromActiveJob()">
        <mat-icon id="refresh-icon">refresh</mat-icon>
        {{ loading ? 'Updating...' : 'Refresh' }}
      </span>
    }
  `,
  styleUrls: ['./refresh.component.scss'],
  imports: [MatIcon]
})
export class RefreshComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() offline: boolean;
  @Input() cloudState: CloudState;

  @Output() refresh: EventEmitter<ElementRef> = new EventEmitter();

  interval;
  updatingTimerInfo = signal<string>('');
  refreshStatus = false;

  constructor(public cleanActiveJobHelper: CleanActiveJobHelper) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cloudState && changes.cloudState.currentValue && changes.cloudState.currentValue === 'RESTING') {
      this.stopTimer();
      this.refreshTimer();
    }
  }

  refreshTimer() {
    let timeElapsed = 0;
    this.updatingTimerInfo.set('Updated just now');

    this.interval = setInterval(() => {
      timeElapsed++;
      if (timeElapsed > 55) {
        this.updatingTimerInfo.set('Updated over an hour ago');
        this.stopTimer();
      } else if (timeElapsed === 1) {
        this.updatingTimerInfo.set('Updated ' + timeElapsed + ' minute ago');
      } else if (timeElapsed % 5 === 0) {
        this.updatingTimerInfo.set('Updated ' + timeElapsed + ' minutes ago');
      }
    }, 60000);
  }

  stopTimer() {
    clearInterval(this.interval);
  }
}
